<script setup lang="ts">
import { computed } from "vue";
export interface SegmentOption { value: string; label: string }

const props = withDefaults(
  defineProps<{ modelValue?: string; options?: (string | SegmentOption)[]; block?: boolean }>(),
  { options: () => [] },
);
defineEmits<{ "update:modelValue": [string] }>();

const normalised = computed<SegmentOption[]>(() =>
  props.options.map((o) => (typeof o === "string" ? { value: o, label: o } : o)),
);
</script>
<template>
  <div
    class="cw-seg"
    :class="{ 'cw-seg--block': block }"
    role="tablist"
  >
    <button
      v-for="opt in normalised"
      :key="opt.value"
      type="button"
      role="tab"
      :aria-selected="opt.value === modelValue"
      class="cw-seg__item"
      :class="{ 'cw-seg__item--active': opt.value === modelValue }"
      @click="$emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>
